import { observable, makeObservable, action } from 'mobx';
// 代码改造---未使用
class VoiceCallStore {
    constructor() {
        makeObservable(this);
    }
    @observable isNewSession = true;

    @action
    setIsNewSession = (flag) => {
        this.isNewSession = flag;
    };

    @observable isInVoiceCall = false;
    @action setIsInVoiceCall = (flag) => {
        this.isInVoiceCall = flag;
    };
    @observable hideTTSActions = true;
    @action setHideTTSActions = (flag) => {
        this.hideTTSActions = flag;
    };
    @observable showChatInterface = true;
    @action setShowChatInterface = (flag) => {
        this.showChatInterface = flag;
    };
    @observable showCameraArea = false;
    @action setShowCameraArea = (flag) => {
        this.showCameraArea = flag;
    };
    @observable pendingChatAction = null;
    @action setPendingChatAction = (action) => {
        this.pendingChatAction = action;
    };
    @observable isInputVisible = true;
    @action setIsInputVisible = (flag) => {
        this.isInputVisible = flag;
    };
    @observable showTTSComponent = false;
    @action setShowTTSComponent = (flag) => {
        this.showTTSComponent = flag;
    };

    // 添加状态控制是否显示聊天界面
    handleTTSToggle = async () => {
        // 隐藏聊天界面
        this.setShowChatInterface(false);
        // 隐藏输入框和 TTS 组件
        this.setIsInputVisible(false);
        this.setShowTTSComponent(true);
        // 显示 CameraArea 组件
        this.setShowCameraArea(true);
        setTimeout(() => {
            // 可以在这里触发TTS连接状态检查
            window.dispatchEvent(new CustomEvent('check-tts-connection'));
        }, 50);
    };
    handleBackToChat = async () => {
        // 显示聊天界面
        this.setShowChatInterface(true);
        // 隐藏 TTS 组件
        this.setShowTTSComponent(false);
        // 显示输入框
        this.setIsInputVisible(true);
        // 隐藏 CameraArea 组件
        this.setShowCameraArea(false);
    };
}

const VoiceCallStoreInstance = new VoiceCallStore();
export default VoiceCallStoreInstance;
